var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2BedroomBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 43h62v11h-4v-7H11v7H7V43zm59.78-10.52A9.5 9.5 0 0059.4 29H33.09a10 10 0 00-6.79 3.48 9.71 9.71 0 00-2.3 6.34V39h45v-.18a9.91 9.91 0 00-2.22-6.34zm-49.46-.24A11.269 11.269 0 008.49 28H7v11h13c0-2.74-.85-4.5-2.68-6.76z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Bedroom_bis.36cf8006.svg";
export { SvgE2BedroomBis as ReactComponent };